module.exports = "button:disabled\r\n{\r\n    background: #f78d77;\r\n}"